/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesUserSchema } from "./userSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesFavoriteChampionSchema = z.object({
  id: z.optional(z.int()),
  userId: z.string().nullish(),
  get user() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
  name: z.string().nullish(),
  image: z.string().nullish(),
  games: z.optional(z.int()),
  winrate: z.optional(z.number()),
});
